import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axiosInstance';

// create push notification
export const createPushNotification = createAsyncThunk(
  'admin/createPushNotification',
  async (requestBody, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const authToken = state.admin.authToken; // Adjust according to your state structure

      const response = await axiosInstance.post('/admin/push_notifications', requestBody, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
    } catch (error) {
      // TO DO: Handle error properly
      alert(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  status: 'idle',
  error: null
};

export const pushNotificationSlice = createSlice({
  name: 'pushNotification',
  initialState,
  reducers: {
    clearPushNotifications: (state) => {
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPushNotification.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createPushNotification.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createPushNotification.rejected, (state, action) => {
        state.error = action.payload;
      })
  }
});

export const { clearMesssages } = pushNotificationSlice.actions;

export default pushNotificationSlice.reducer;
